import { CircleCheck } from 'lucide-react';

// Rendered at h-8, so these are 2x. `width` is each file's real width, set on
// the tag so the row reserves its space before the images decode.
const partners = [
  {
    name: 'Stanford Medicine',
    logo: '/logos/stanford-medicine.webp',
    width: 234,
  },
  { name: 'Mayo Clinic', logo: '/logos/mayo-clinic-health.webp', width: 260 },
  { name: 'UCSF', logo: '/logos/ucsf.webp', width: 92 },
  {
    name: 'Emory Healthcare',
    logo: '/logos/emory-healthcare.webp',
    width: 184,
  },
  { name: 'University of Iowa', logo: '/logos/iowa-clinics.webp', width: 165 },
  {
    name: 'Boston Medical Center',
    logo: '/logos/boston-medical-brighton.webp',
    width: 102,
  },
];

export function TrustSignals({
  hideTestimonial = false,
}: { hideTestimonial?: boolean } = {}) {
  return (
    <div className="p-6 bg-background-subtle rounded-lg h-full flex flex-col">
      {/* Trusted by statement */}
      <p className="text-body-small-strong text-center mb-4">
        Trusted by over 500 providers and law firms
      </p>

      {/* Partner logos */}
      <div className="flex flex-wrap justify-center items-center gap-4 mb-4">
        {partners.map(partner => (
          <img
            key={partner.name}
            src={partner.logo}
            alt={partner.name}
            width={partner.width}
            height={64}
            className="h-8 w-auto grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all object-contain"
          />
        ))}
      </div>

      {/* HIPAA Badge */}
      <div className="flex justify-center mb-4">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-secondary rounded-lg text-sm">
          <CircleCheck className="h-4 w-4 text-primary" />
          <span className="font-medium">
            HIPAA Compliant &amp; BAA Included
          </span>
        </div>
      </div>

      {/* Testimonial */}
      {!hideTestimonial && (
        <blockquote className="text-center border-l-4 border-primary pl-4 mx-auto max-w-sm mt-auto">
          <p className="text-sm italic mb-2 text-long-secondary">
            &quot;Using Expected Health has made our imaging referrals 100%
            easier and our patients love the experience. It brings faxed
            referrals to the 21st Century.&quot;
          </p>
          <cite className="text-xs text-body-base not-italic">
            — Dr. Andrews, Family Nurse Practitioner
          </cite>
        </blockquote>
      )}
    </div>
  );
}
